import React, { useEffect, useState } from "react";
import "./Home.css";
import axios from "axios";
import heroSrc from "../image/banner.png";
import image from '../../src/image/main-logo.png';
import { motion } from "framer-motion";
import Footer from "./Footer";
import { FaBook, FaInfinity, FaRegCreditCard, FaUserGraduate } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { PiStudent } from "react-icons/pi";
import { MdOutlinePlayLesson } from "react-icons/md";
import WhyChoose from "./WhyChoose";

import StudentReviews from './StudentReviews.jsx';
import Navbar from "./Navbar.jsx";
import HomeCourses from "./HomeCourses.jsx";
import Certificate from  "./Certificate_Courses.jsx"


const API = "https://course-selling-backend-2-rr1n.onrender.com";




const NavLink = ({ children, href = "#" }) => (
    <a className="mh-navlink" href={href}>
        {children}
    </a>
);

export default function Home() {


    const [courses, setCourses] = useState([]);
    const [count, setCount] = useState(0); // ✅ for counter animation




    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const [showAlert, setShowAlert] = useState(false);


    const features = [
        { icon: <FaBook />, title: "Extensive Resources" },
        { icon: <FaInfinity />, title: "Lifetime Privileges" },
        { icon: <FaRegCreditCard />, title: "Affordable Education" },
        { icon: <FaUserGraduate />, title: "Dedicated Support" },
    ];

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const token = localStorage.getItem("token");

                if (!token) return;
            } catch (err) {
                console.error(err);
            }
        };

        // ✅ check token
        const token = localStorage.getItem("token");
        console.log("TOKEN FROM LOCALSTORAGE:", token);
        setIsAuthenticated(!!token);


        axios
            .get(`${API}/api/courses`)
            .then((res) => setCourses(res.data))
            .catch((err) => console.error(err));

        fetchUser();

        // ✅ Animate stats counter
        let start = 0;
        const end = 15800; // 15.8k
        const duration = 2000;
        const increment = end / (duration / 16);

        const timer = setInterval(() => {
            start += increment;
            if (start >= end) {
                setCount(end);
                clearInterval(timer);
            } else {
                setCount(Math.floor(start));
            }
        }, 16);

        return () => clearInterval(timer);
    }, []);

    const handleClick = () => {
        navigate("/Certificate_Courses"); // yahan "/about" aapka target route hai
    };

    // ✅ New function: Navigate to course details page
    const handleViewCourse = (courseId) => {
        navigate("/Certificate_Courses");
    };


    return (
        <>
            <header className="mh-header">
                {/* top strip */}
                <Navbar />

                {/* hero */}
                <section id="home" className="mh-hero">

                    <div className="mh-container mh-hero-grid">
                        {/* LEFT */}
                        <div className="mh-hero-left">
                            <div className="mh-badge">
                                <span className="mh-dot" />UNLOCKING THE FUTURE OF MEDICAL EXPERTISE
                            </div>
                            <h1 className="mh-title">
                                <span>Your Pathway to</span><br></br>
                                <span className="mh-highlight">Medical</span><br></br>
                                Excellence
                            </h1>
                            <h5 className="mh-sub">
                                Explore Specialized Medical Learning
                            </h5>

                            <div className="mh-ctas">

                                <button className="mh-cta-primary" onClick={handleClick}> 
                                    Explore Courses
                               </button>
                                <button className="mh-cta-primary"> <NavLink href="/Contact" >
                                    Contact Us
                                </NavLink></button>
                            </div>
                        </div>

                        {/* RIGHT */}
                        <div className="mh-hero-right">

                            {/* ✅ Animated Ring */}
                            <motion.div
                                className="mh-ring"
                                animate={{ rotate: 360 }}
                                transition={{ repeat: Infinity, duration: 10, ease: "linear" }}
                            />
                            {/* ✅ Animate Hero Image */}
                            <motion.img
                                src={heroSrc}
                                alt="Hero visual"
                                className="mh-hero-image"
                                initial={{ scale: 0.8, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 1 }}
                            />

                            {/* ✅ Animate Stats */}
                            <motion.div
                                className="mh-stats"
                                initial={{ y: 50, opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                transition={{ duration: 1, delay: 0.5 }}
                            >
                                <div className="mh-stats-icon">👥</div>
                                <div>
                                    <div className="mh-stats-number">
                                        {count.toLocaleString()}+
                                    </div>
                                    <div className="mh-stats-label">Class Completed</div>
                                </div>
                            </motion.div>
                        </div>
                    </div>
                </section>
            </header>

            <div className="features-container">
                {features.map((item, index) => (
                    <div key={index} className="feature-card">
                        <div className="icon-box">{item.icon}</div>
                        <h3>{item.title}</h3>
                    </div>
                ))}
            </div>

            <HomeCourses/>

            <WhyChoose />
            <section>
                <StudentReviews />
            </section>

            <section>
                <Footer />
            </section>
        </>
    );
}


